import { RealtySource } from 'shared/api/kyrgyzstan/search/model'

type DetailContentSection = 'policies'

const detailContentSectionSources: Record<
  DetailContentSection,
  Set<RealtySource>
> = {
  policies: new Set([RealtySource.INTERNAL]),
}

export const shouldShowDetailContentSection = (
  source: RealtySource | undefined,
  section: DetailContentSection,
): boolean => {
  if (!source) {
    return false
  }

  return detailContentSectionSources[section].has(source)
}

export const shouldShowPoliciesSection = (
  source: RealtySource | undefined,
): boolean => shouldShowDetailContentSection(source, 'policies')
